import { IntlShape } from 'react-intl';
import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { EditPassportTitleFormVM } from './edit-passport-title-form.viewmodel';
import { EditPassportTitleFormPresentation } from './edit-passport-title-form-presentation';

export interface IEditPassportTitleFormContainerProps {
    accountId: number;
    eventId: number;
    intl: IntlShape;
}

const EditPassportTitleFormContainer = withViewModel(EditPassportTitleFormPresentation,
    async (props: IEditPassportTitleFormContainerProps) => {
        const { accountId, eventId, intl } = props;
        const passportSettingsFormVM = new EditPassportTitleFormVM(
            accountId,
            eventId,
            intl
        );
        await passportSettingsFormVM.initialize();

        return passportSettingsFormVM;
    });

export { EditPassportTitleFormContainer as EditPassportTitleForm };